module.exports = __webpack_public_path__ + "static/04_MC-387a9d7a9660191139226116b79aff8e.png";